import React from 'react';
import { Icon } from '@gumtree/ui-library';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { goBack } from '@gumtree/ui-library/src/button/button-service';
import { BackButton, SimpleHeader, SimpleHeaderContainer } from './simple-header.style';
import { NavLogo } from '../nav-bar/style';

const Header = () => {
    return (
        <SimpleHeaderContainer>
            <SimpleHeader>
                <BackButton onClick={goBack}>
                    <Icon type="chevron-l-light" size="small" />
                    Back to Ad
                </BackButton>
                <NavLogo linkTo="/" {...qaAttribute('gumtree-logo')} data-testid="gumtree-logo" />
            </SimpleHeader>
        </SimpleHeaderContainer>
    );
};

export default Header;
